import { useState, useEffect } from "react";
import "./QuestionSettingsSection.css";
import { QuestionSelector } from "../question-selector/QuestionSelector";
import { Question, QuestionType, UpdateQuestionPayload } from "effno-core";
import { apiUpdateQuestion } from "../../services/QuestionService";
import toast from "react-hot-toast";
import { toastFail } from "../../config";

type QuestionSettingsSectionProps = {
    question: Question;
    onChange: (question: Question) => void;
}

export const QuestionSettingsSection = ({question, onChange} : QuestionSettingsSectionProps) => {

    const [settings, setSettings] = useState<any | null>(JSON.parse(question.settings));
    const [type, setType] = useState<QuestionType>(question.type);
    const [required, setRequired] = useState<boolean>(question.required);

    useEffect(() => {
        setSettings(JSON.parse(question.settings));
        setRequired(question.required);
        setType(question.type);
    }, [question]);

    const handleTypeChange = async (value: string) => {
        console.log("[QuestionSettingsSection/handleTypeChange] value: ", value);
    }

    // const handleRequiredChange = async (checked: boolean) => {
    //     setRequired(checked);

    //     const payload: UpdateQuestionPayload = {
    //         questionId: question.id,
    //         type,
    //         title: question.title,
    //         description: question.description,
    //         required: checked,
    //         settings: JSON.stringify(settings),
    //         conditions: question.conditions
    //     }

    //     updateSettings(payload);
    // }

    const handleSettingChange = async (e: any) => {
        console.log("[QuestionSettingsSection/handleSettingChange] e: ", e);

        let newSettings = {...settings};

        switch (e.target.name) {
            case "fontSize":
                newSettings = {...settings, fontSize: parseInt(e.target.value)};
                break;
            default:    
                newSettings = {...settings, [e.target.name]: e.target.value};
        }

        setSettings(newSettings);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required,
            settings: JSON.stringify(newSettings),
            conditions: question.conditions
        }

        updateSettings(payload)
    }

    // have to send in the payload here due to react setting asyncs
    const updateSettings = async(payload: UpdateQuestionPayload) => {

        const newQuestion = await apiUpdateQuestion(payload);

        if (!newQuestion) {
            toast("Error updating question", toastFail);
            return;
        }

        // update UI
        onChange(newQuestion);
    }

    // console.log("[QuestionSettingsSection] settings: ", settings);

    return (        
        <>
            <div className="question-settings-number">
                {/* <QuestionSelector defaultValue={type} onChange={handleTypeChange}/>

                <div className="question-setting-divider">{}</div> */}

                <div className="question-setting-stack">
                    <div className="question-setting-stack-top">
                        <div className="question-setting-label">
                            Font size
                        </div>
                        <div className="question-setting-input">
                            <input 
                                type="number"
                                name="fontSize"
                                value={settings?.fontSize} 
                                onChange={handleSettingChange}
                                data-testid="fontSize"
                            />
                        </div>
                    </div>
                        
                </div>
            </div>
            
        </>
    )
}